const apiUrl = process.env.REACT_APP_API_URL;

const getFiltrationMethods = (token, cb) => {
    fetch(`${apiUrl}/filtrationmethods`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getFiltrationMethods;
